import { Person, PersonRaw } from "frontend/interfaces/p/person";

export function parsePerson(personRaw: PersonRaw): Person {
  return {
    ...personRaw,
  };
}
